import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

import { UserInfoService } from '../../services/user-info/user-info.service';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
})
export class CookiesComponent implements OnInit, AfterViewInit {

  @Output() cookiesAcceptedEvent = new EventEmitter<boolean>();

  @ViewChild('acceptCookieButton') acceptCookieButton: ElementRef;
  @ViewChild('cookiesModal') cookiesModal: TemplateRef<any>;

  cookiesModalRef: BsModalRef;

  constructor(
    private readonly userInfoService: UserInfoService,
    private readonly translate: TranslateService,
    private readonly modalService: BsModalService
  ) { }

  cookiesAccepted: boolean;
  cookiesTextTitle: string;
  cookiesTextP1: string;
  cookiesTextP2: string;
  cookiesTextButton: string;

  ngOnInit(): void {
    this.configTexts();
    this.cookiesAccepted = this.userInfoService.getCookiesAccepted();
  }
  
  ngAfterViewInit() {
    if (!this.cookiesAccepted) {
      this.cookiesModalRef = this.modalService.show(this.cookiesModal, {ignoreBackdropClick: true,});
      document.getElementById('cookiesButton').focus();
    }
  }
  
  onAccept(): void {
    this.userInfoService.storeCookiesAccepted();
    this.cookiesAccepted = true;
    this.cookiesModalRef.hide();
    this.cookiesAcceptedEvent.emit(true);
  }

  hideCookieModal(): void {
    this.cookiesModalRef.hide();
  }

  configTexts(): void {
    this.translate.get('last').subscribe(() => {
      this.cookiesTextTitle = this.translate.instant(`cookies.title`);
      this.cookiesTextP1 = this.translate.instant(`cookies.firstParagraph`);
      this.cookiesTextP2 = this.translate.instant(`cookies.secondParagraph`);
      this.cookiesTextButton = this.translate.instant(`cookies.button`);
    });
  }

}
